import { useCheckoutPageSetup } from '@/booking/hooks/use-checkout-page-setup.hook';
import { type BookingCheckoutStep } from '@/booking/hooks/use-redirect-to-correct-step.hook';

export function CheckoutPageSideEffects({
  hotelSlug,
  bookingId,
  checkoutStep,
}: {
  hotelSlug: string;
  bookingId: string;
  checkoutStep: BookingCheckoutStep;
}) {
  useCheckoutPageSetup({
    hotelSlug,
    bookingId,
    checkoutStep,
  });

  return null;
}
